import React, { useLayoutEffect } from 'react';
import * as PropTypes from 'prop-types';
/**/
import SmartSearch from '../SmartSearch/SmartSearch';
import pages from '../../define/pages';

// An empty state stands in for parts of the page that Twig already rendered:
// on the history page, the page title and the "search more" action. Hide them
// for as long as it is on screen, before the browser paints them.
const useReplaced = (selector) => {
  useLayoutEffect(() => {
    if (!selector) return undefined;

    const replaced = document.querySelectorAll(selector);
    const hide = (hidden) =>
      Array.prototype.forEach.call(replaced, (node) => {
        node.hidden = hidden;
      });

    hide(true);
    return () => hide(false);
  }, [selector]);
};

// The 404 page is server rendered and repeats this markup in views/404.twig,
// because Twig cannot mount a React component. Keep the two in step.
const EmptyState = ({
  sources,
  titleLead,
  titleRest,
  text,
  ctaLabel,
  replaces,
}) => {
  useReplaced(replaces);

  return (
    <div className="empty-state">
      <div className="empty-state__media">
        <video autoPlay loop muted playsInline>
          {sources.map((src) => (
            <source
              key={src}
              src={src}
              type={`video/${src.split('.').pop()}`}
            />
          ))}
        </video>
      </div>

      <h1>
        {titleLead} <br />
        {titleRest}
      </h1>
      <p>{text}</p>

      <div className="empty-state__actions">
        <div className="smart-search">
          <SmartSearch />
        </div>
        <a href={pages.catalogue} className="btn btn--primary">
          {ctaLabel}
        </a>
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  sources: PropTypes.arrayOf(PropTypes.string).isRequired,
  titleLead: PropTypes.string.isRequired,
  titleRest: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  ctaLabel: PropTypes.string.isRequired,
  replaces: PropTypes.string,
};

export default EmptyState;
